import { useEffect, useState } from 'react';

export default function MaintenanceScreen() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <img 
            src="/favicon.png" 
            alt="真決DAO" 
            className="w-24 h-24 mx-auto mb-4 animate-pulse"
          />
          <h2 className="text-xl font-bold text-gray-700 mb-2">真決DAO</h2>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-3">
          🔧 システムメンテナンス中
        </h1>

        <p className="text-gray-600 mb-6">
          現在、システムの更新を行っています
          <br />
          <span className="inline-block min-w-[3ch]">
            しばらくお待ちください{dots}
          </span>
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            <span className="font-semibold">📅 予定時間:</span> 数分程度
          </p>
        </div>

        <div className="flex justify-center gap-2 mb-4">
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

        <p className="text-xs text-gray-500">
          完了次第、自動的に画面が切り替わります
        </p>
      </div>
    </div>
  );
}
